// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import connectActions from 'utils/connectActions'

// Actions
import { logOut } from 'actions/me'
import { AppProgressActivator } from 'atoms/AppProgress'
import ErrorCard from 'atoms/ErrorCard'
import ContentLoader from 'atoms/ContentLoader'

const mapActionsToProps = {
  logOutAction: logOut
}

export default
@connectActions(mapActionsToProps)
@withRouter
class LogoutAction extends Component {
  static propTypes = {
    logOutAction: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    token: PropTypes.string,
  }

  async componentDidMount() {
    const { logOutAction, token, history } = this.props
    try {
      await logOutAction.run({
        params: [token],
        updateComponentOnSuccess: false
      })
      history.replace('/login')
    } catch (error) {
      // do nothing
    }
  }

  render() {
    const { logOutAction } = this.props
    return logOutAction.isFailed ? (
      <ErrorCard
        primary="Error"
        secondary={logOutAction.error.message}
        withHomeAction
      />
    ) : (
      <Fragment>
        <AppProgressActivator />
        <ContentLoader centered />
      </Fragment>
    )
  }
}
